import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { animateTextBanner, getLabelFallback } from '@utils/utils';
import ApplePay from '@images/svg-icons/apple_pay.svg';
import * as actions from '@redux-actions/';


type ApplePayButtonProps = {
  expressCheckout: boolean,
  smartGlassesError?: string;
};

const ApplePayButton = (props: ApplePayButtonProps): ReactElement => {
  const { expressCheckout,
          smartGlassesError = ''
        } = props;

  const config = useSelector(state => state.cart.config);

  const handleApplePayButtonClick = () => {
    config.callFromComponentToGl.onApplePayButtonClicked(expressCheckout);
    var paymentMethod="";
    if (expressCheckout) {
      paymentMethod="ApplePayExpressCheckout";
    } else {
      paymentMethod="ApplePay";
    }
    localStorage.setItem('Order_PaymentType', paymentMethod);
  }

  return (
    <> 
    {smartGlassesError == null || smartGlassesError.length === 0 ?
    <button aria-label={getLabelFallback('APPLE_PAY_LABEL')} id="applepay-button" data-element-id='Summary_ApplePayCheckout'
      onClick={() => handleApplePayButtonClick()}>
      <ApplePay />
    </button> :
    <button aria-label={getLabelFallback('APPLE_PAY_LABEL')} id="applepay-button" className="disabled" data-element-id='Summary_ApplePayCheckout'
      onClick={animateTextBanner}>
      <ApplePay />
    </button>
    }
    </>
  )
};

export default ApplePayButton;
